// src/pages/NotFound.jsx
import React from 'react';

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 text-center p-6">
      <div>
        <h1 className="text-5xl font-bold text-red-500 mb-4">404</h1>
        <p className="text-xl text-gray-700 mb-6">Trang bạn tìm không tồn tại.</p>
        <a href="/" className="text-blue-500 hover:underline">
          Quay lại trang chủ
        </a>
      </div>
    </div>
  );
};

export default NotFound;
